import React from "react";

export const BlackListContext = React.createContext({});
